import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstLetter'
})
export class CapitalizeFirstLetterPipe implements PipeTransform {

  transform(str: string): string {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : null;
  }

}
